import {
  Box,
  Button,
  Divider,
  Skeleton,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useAuth } from "src/hooks/useAuth";
import { PaymentReciept } from "src/icons/reciept";
import { currencyFormat } from "src/utility/Utils";
import ProductServices from "src/services/product";
import styled from "@emotion/styled";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";
import { useProductStore } from "../store/useProductStore";
import { SupportProductButton } from "./SupportProductButton";
import {featureIsActive} from "../../../utility/featureController";
import {toast} from "react-toastify";

const FixedBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    position: "fixed",
    bottom: theme.spacing(theme.mixins.toolbar.minHeight / 5),
    left: 0,
    right: 0,
    backgroundColor: "white",
    padding: 10,
    borderTop: "1px solid #efefef",
  },
}));

export const PriceInfo = (props) => {
  const {
    product: mainProduct,
    onAddtoCartClick,
    productImage,
    productTitle,
    isProductLoading,
    deliveryPrice = 0,
    addToCartLoading,
    uaeDeliveryPrice = "",
  } = props;
  const { isLogin } = useAuth();
  const router = useRouter();
  const setProductPrice = useProductStore((state) => state.setProductPrice);

  const [deliveryType, setDeliveryType] = useState("1"); // 1 is Sea, 2 is Air
  const [product, setProduct] = useState(mainProduct);

  const productPriceMutation = useMutation(ProductServices.fetchProductPrice, {
    onSuccess: (data) => {
      if (data.data.content) {
        setProduct((prev) => ({
          ...prev,
          price: data.data.price,
          price_sea: data.data.sea_price,
          price_air: data.data.air_price,
          mozonoVolume: data.data.content,
        }));

        setProductPrice(data.data.sea_price.total_price);
      }
    },
    onError: (err) => {},
    onSettled: () => {},
  });

  useEffect(() => {
    (async () => {
      const productInfo = {
        title: productTitle,
        image: productImage,
        // category:
        //   mainProduct?.extra_items?.breadcrumbs?.reduce(
        //     (accumulator, currentValue) => accumulator + currentValue + " -> ",
        //     ""
        //   ) || "",
      };

      await productPriceMutation.mutateAsync({
        price: mainProduct?.price,
        delivery_price: uaeDeliveryPrice
          ? Number(`${uaeDeliveryPrice}`.replace("AED", ""))
          : 0,
        productInfo,
        productId: mainProduct?.id || 0,
        url: mainProduct?.url || "",
      });
    })();
  }, [JSON.stringify(mainProduct)]);

  useEffect(() => {
    if (product.price_sea) {
      deliveryType === "1"
        ? setProductPrice(product.price_sea.total_price)
        : setProductPrice(product.price_air.total_price);
    }
  }, [deliveryType]);

  const handleAddToCartClick = () => {
    // if (!isLogin) {
    //   router.push(`/login?redirect=/product/dp/${router.query.code}`);
    //   return;
    // }
    onAddtoCartClick(
      deliveryType === "1"
        ? { ...product.price, ...product.price_sea }
        : { ...product.price, ...product.price_air },
      deliveryType === "1" ? product.price_sea.user_delivery_type : deliveryType
    );
  };

  let cargoPrice,
    cartTotalPrice,
    deliveyPrice = 0;
  if (deliveryType === "1") {
    cargoPrice =
      +product?.price_sea?.wage +
      +product?.price_sea?.delivery_price +
      product?.price_sea?.tax;

    deliveyPrice = +product?.price_sea?.delivery_price;

    cartTotalPrice = product?.price_sea?.total_price;
  }

  if (deliveryType === "2") {
    cargoPrice =
      +product?.price_air?.wage +
      +product?.price_air?.delivery_price +
      product?.price_air?.tax;

    deliveyPrice = +product?.price_air?.delivery_price;

    cartTotalPrice = product?.price_air?.total_price;
  }

  const showDisabledToast = () => {
    if (!featureIsActive('airDelivery')) {
      toast.warning('تا پایان تعطیلات نوروز سرویس هوایی غیرفعال می باشد. ( تا ۱۶ فرودین )')
    }
  }

  return (
    <>
      {!product?.code?.startsWith("/ir/") && <Divider sx={{ my: 3 }} />}
      <Typography display={"flex"} alignItems={"center"}>
        <PaymentReciept sx={{ mr: 2, color: "primary.main" }} />
        محاسبه قیمت
      </Typography>

      {productPriceMutation.isLoading ? (
        <>
          <Skeleton height={15} sx={{ mt: 4 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Skeleton height={15} sx={{ mt: 2 }} />
          <Divider sx={{ my: 3 }} />

          <Skeleton height={70} sx={{}} />
          <FixedBox sx={{ display: { lg: "none" } }}>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-around"}
              sx={{ mb: 4 }}
            >
              <Skeleton height={40} width={200} sx={{ mx: 0.5 }} />
              <Skeleton height={40} width={200} sx={{ mx: 0.5 }} />
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{ mb: 4 }}
            >
              <Skeleton height={40} width={200} sx={{ mx: 0.5 }} />
              <Skeleton height={40} width={200} sx={{ mx: 0.5 }} />
            </Box>
          </FixedBox>
        </>
      ) : (
        productPriceMutation.isSuccess && (
          <>
            {product?.price?.price_type === "cart" && (
              <>
                <Box
                  mt={5}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="body2" color={grey[600]}>
                    قیمت کالا به درهم :
                  </Typography>
                  <Typography variant="body2" color={grey[600]}>
                    {product?.price?.dirham_price} درهم
                  </Typography>
                </Box>

                {/* {uaeDeliveryPrice !== "" && uaeDeliveryPrice !== "FREE" && (
                  <Box
                    mt={5}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Typography variant="body2" color={grey[600]}>
                      هزینه ارسال تا انبار امارات :
                    </Typography>
                    <Typography variant="body2" color={grey[600]}>
                      {`${uaeDeliveryPrice}`.replace("AED", "")} درهم
                    </Typography>
                  </Box>
                )} */}

                {product?.price?.dirham_price !==
                  product?.price?.old_dirham_price &&
                  product?.price?.saving_percent > 0 && (
                    <Box
                      mt={4}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography variant="body2" color={grey[600]}>
                        تخفیف محصول:
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ "& span": { mr: 2 } }}
                        color={"error.main"}
                      >
                        <del>
                          {currencyFormat(
                            product?.price?.old_toman_price +
                              +product?.price?.delivery_price +
                              product?.price.tax +
                              product?.price.wage
                          )}
                        </del>
                        <span>-{product?.price?.saving_percent}%</span>
                      </Typography>
                    </Box>
                  )}

                {product?.price?.dirham_price !==
                  product?.price?.old_dirham_price &&
                  product?.price?.saving_percent > 0 && (
                    <Box
                      mt={4}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                    >
                      <Typography variant="body2" color={grey[600]}>
                        مقدار تخفیف :
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ "& span": { ml: 1 } }}
                        color={"error.main"}
                      >
                        {currencyFormat(
                          product?.price?.old_toman_price -
                            product?.price?.toman_price
                        )}{" "}
                        <span>تومان</span>
                      </Typography>
                    </Box>
                  )}

                <Box
                  mt={4}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="body2" color={grey[600]}>
                    قیمت کالا به تومان:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ "& span": { ml: 1 } }}
                    color={grey[600]}
                  >
                    {currencyFormat(product?.price?.toman_price)}{" "}
                    <span>تومان</span>
                  </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ display: { xs: "none", lg: "block" } }}>
                  <Typography variant="body2" color={grey[600]}>
                    نوع ارسال:
                  </Typography>

                  <RadioGroup
                    // row

                    value={deliveryType}
                    onChange={(v) => {
                      setDeliveryType(v.target.value);
                    }}
                    sx={{
                      justifyContent: "space-between",
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      sx={{
                        border: 1,
                        borderColor:
                          deliveryType === "1" ? "primary.main" : "#D5D7DA",
                        borderRadius: 2,
                        height: 40,
                        margin: 0,
                        mt: 2,

                        p: "8px !important",
                        "& span": {
                          fontSize: "14px !important",
                          fontWeight: 600,
                        },
                      }}
                      control={<Radio size="small" sx={{ p: 0 }} />}
                      label="دریایی ( ۴ الی ۸ هفته کاری )"
                      disabled={!product?.price_sea?.can_sea}
                    />

                    <FormControlLabel
                      value="2"
                      sx={{
                        border: 1,
                        borderColor:
                          deliveryType === "2" ? "primary.main" : "#D5D7DA",
                        borderRadius: 2,
                        height: 40,
                        margin: 0,
                        mt: 2,

                        p: "8px !important",
                        "& span": {
                          fontSize: "14px !important",
                          fontWeight: 600,
                        },
                      }}
                      control={<Radio size="small" sx={{ p: 0 }} />}
                      label="هوایی ( ۲ الی ۴ هفته کاری )"
                      disabled={!product?.price_air?.can_air || !featureIsActive('airDelivery')}
                      title={!featureIsActive('airDelivery') ? "به صورت موقت غیرفعال است." : undefined}
                      onClick={showDisabledToast}
                    />
                  </RadioGroup>
                  {product?.price_air?.can_air === 0 &&
                    product?.price_sea?.can_sea === 1 && (
                      <Typography variant="subtitle2" mt={2}>
                        ارسال این کالا به دلیل محدودیت به صورت هوایی ممکن نیست
                      </Typography>
                    )}
                  {product?.price_air?.can_air === 0 &&
                    product?.price_sea?.can_sea === 0 && (
                      <Typography variant="subtitle2" mt={2}>
                        متاسفانه به دلیل محدودیت حجم یا وزن کالا ثبت سفارش برای
                        آن امکان پذیر نمی باشد
                      </Typography>
                    )}

                  {deliveryType === "2" && (
                    <Typography
                      variant="subtitle2"
                      mt={2}
                      sx={{ "& span": { fontWeight: 600, color: "black" } }}
                    >
                      <span>توجه : </span>
                      بازه زمانی ارسال بعد از دریافت و تایید کالا در انبار
                      امارات شروع خواهد شد.
                    </Typography>
                  )}
                  {product?.mozonoVolume?.isShoe && deliveryType === "2" && (
                    <Typography
                      variant="subtitle2"
                      mt={1}
                      sx={{ "& span": { fontWeight: 600, color: "black" } }}
                    >
                      {/* <span>توجه : </span> */}
                      ارسال کفش و کتونی به صورت هوایی بدون کارتن می باشد
                    </Typography>
                  )}
                </Box>

                <Box
                  mt={4}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="body2" color={grey[600]}>
                    کارمزد و هزینه کارگو:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ "& span": { ml: 1 } }}
                    color={grey[600]}
                  >
                    {!product?.price?.dirham_price
                      ? 0
                      : currencyFormat(cargoPrice || 0)}
                    <span>تومان</span>
                  </Typography>
                </Box>

                {/* <Box
                  mt={4}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="body2" color={grey[600]}>
                    هزینه ارسال:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ "& span": { ml: 1 } }}
                    color={grey[600]}
                  >
                    {!product?.price?.dirham_price
                      ? 0
                      : currencyFormat(deliveyPrice)}{" "}
                    <span>تومان</span>
                  </Typography>
                </Box> */}

                <Divider sx={{ my: 3 }} />
                <Box
                  mt={4}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography variant="body1">قیمت نهایی کالا:</Typography>
                  <Typography
                    variant="body1"
                    sx={{ "& span": { ml: 1 } }}
                    color={"primary.dark"}
                  >
                    {currencyFormat(
                      product?.price?.dirham_price ? cartTotalPrice || 0 : 0
                    )}{" "}
                    <span>تومان</span>
                  </Typography>
                </Box>
              </>
            )}
            <Divider sx={{ my: 3 }} />
            {product?.price?.price_type === "range" ? (
              <Typography color="primary.main">
                برای افزودن به سبد خرید نوع محصول خود را انتخاب کنید
              </Typography>
            ) : !isProductLoading && !product?.price?.dirham_price ? (
              <Typography textAlign={"center"} color="primary.main">
                محصول موجود نمی باشد
              </Typography>
            ) : (
              <FixedBox>
                {addToCartLoading ? (
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    textAlign={"center"}
                    height={80}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      fullWidth
                      size="medium"
                      sx={{
                        display: { xs: "none", lg: "block" },
                        boxShadow: "none !important",
                      }}
                      onClick={handleAddToCartClick}
                      disabled={
                        (deliveryType === "1" &&
                          product?.price_sea?.can_sea === 0) ||
                        (deliveryType === "2" &&
                          product?.price_air?.can_air === 0) ||
                        (product?.price_sea?.can_sea === 0 &&
                          product?.price_air?.can_air === 0)
                      }
                    >
                      افزودن به سبد خرید
                    </Button>
                    {product?.price_sea?.can_sea === 0 &&
                      product?.price_air?.can_air === 0 && (
                        <SupportProductButton
                          buttonProps={{
                            sx: {
                              color: "black",
                              mt: 1,
                              display: { xs: "none", lg: "block" },
                            },
                            fullWidth: true,
                            size: "medium",
                          }}
                        />
                      )}

                    <Box sx={{ display: { lg: "none" } }}>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        mb={3}
                      >
                        {product?.price_sea?.can_sea === 0 &&
                          product?.price_air?.can_air === 0 && (
                            <SupportProductButton
                              buttonProps={{
                                variant: "outlined",
                                sx: {
                                  color: "black",
                                },
                                size: "small",
                              }}
                            />
                          )}

                        {(product?.price_sea?.can_sea === 1 ||
                          product?.price_air?.can_air === 1) && (
                          <Typography
                            variant="body1"
                            textAlign={"center"}
                            sx={{
                              flex: 1,
                              "& span": { ml: 1, color: "#C6C6C6" },
                            }}
                            fontWeight={600}
                          >
                            {currencyFormat(
                              product?.price?.dirham_price ? cartTotalPrice : 0
                            )}
                            <span>تومان</span>
                          </Typography>
                        )}
                        <Button
                          variant="contained"
                          // fullWidth

                          size="medium"
                          sx={{ width: 205, marginLeft: 10 }}
                          onClick={handleAddToCartClick}
                          disabled={
                            (deliveryType === "1" &&
                              product?.price_sea?.can_sea === 0) ||
                            (deliveryType === "2" &&
                              product?.price_air?.can_air === 0) ||
                            (product?.price_sea?.can_sea === 0 &&
                              product?.price_air?.can_air === 0)
                          }
                        >
                          افزودن به سبد خرید
                        </Button>
                      </Box>
                      <RadioGroup
                        row
                        value={deliveryType}
                        onChange={(v) => {
                          setDeliveryType(v.target.value);
                        }}
                        sx={{ justifyContent: "space-around" }}
                      >
                        <FormControlLabel
                          value="1"
                          sx={{
                            border: 1,
                            borderColor:
                              deliveryType === "1" ? "primary.main" : "#D5D7DA",
                            borderRadius: 2,
                            height: 40,
                            margin: 0,

                            paddingRight: "4px !important",

                            "& span": {
                              fontSize: "11px !important",
                              fontWeight: 600,
                            },
                          }}
                          control={<Radio size="small" sx={{ p: 0 }} />}
                          label="دریایی (۴ الی ۸ هفته کاری)"
                          disabled={!product?.price_sea?.can_sea}
                        />

                        <FormControlLabel
                          value="2"
                          sx={{
                            border: 1,
                            borderColor:
                              deliveryType === "2" ? "primary.main" : "#D5D7DA",
                            borderRadius: 2,
                            height: 40,
                            margin: 0,

                            paddingRight: "4px !important",
                            "& span": {
                              fontSize: "11px !important",
                              fontWeight: 600,
                            },
                          }}
                          control={<Radio size="small" sx={{ p: 0 }} />}
                          label="هوایی (۲ الی ۴ هفته کاری)"
                          disabled={!product?.price_air?.can_air || !featureIsActive('airDelivery')}
                          title={!featureIsActive('airDelivery') ? "به صورت موقت غیرفعال است." : undefined}
                          onClick={showDisabledToast}
                        />
                      </RadioGroup>
                      {product?.price_air?.can_air === 0 &&
                        product?.price_sea?.can_sea === 1 && (
                          <Typography variant="subtitle2" mt={2}>
                            ارسال این کالا به دلیل محدودیت به صورت هوایی ممکن
                            نیست
                          </Typography>
                        )}
                      {product?.price_air?.can_air === 0 &&
                        product?.price_sea?.can_sea === 0 && (
                          <Typography variant="subtitle2" mt={2}>
                            متاسفانه به دلیل محدودیت حجم یا وزن کالا ثبت سفارش
                            برای آن امکان پذیر نمی باشد
                          </Typography>
                        )}
                      {deliveryType === "2" && (
                        <Typography
                          variant="subtitle2"
                          mt={2}
                          sx={{ "& span": { fontWeight: 600, color: "black" } }}
                        >
                          <span>توجه : </span>
                          بازه زمانی ارسال بعد از دریافت و تایید کالا در انبار
                          امارات شروع خواهد شد.
                        </Typography>
                      )}
                      {product?.mozonoVolume?.isShoe &&
                        deliveryType === "2" && (
                          <Typography
                            variant="subtitle2"
                            mt={1}
                            sx={{
                              "& span": { fontWeight: 600, color: "black" },
                            }}
                          >
                            {/* <span>توجه : </span> */}
                            ارسال کفش و کتونی به صورت هوایی بدون کارتن می باشد
                          </Typography>
                        )}
                    </Box>
                  </>
                )}
              </FixedBox>
            )}
            {/* <Divider sx={{ my: 3 }} />
            <Typography
              display={"flex"}
              mt={1}
              variant="body2"
              alignItems={"center"}
            >
              {isProductLoading ? (
                <Skeleton sx={{ flex: 1 }} />
              ) : (
                `ابعاد : ${
                  product?.mozonoVolume?.dimensions
                    ? "(cm)" + product?.mozonoVolume?.dimensions
                    : "نامعلوم"
                }`
              )}
            </Typography> */}
            {/* <Typography
              display={"flex"}
              mt={1}
              variant="body2"
              alignItems={"center"}
            >
              {isProductLoading ? (
                <Skeleton sx={{ flex: 1 }} />
              ) : (
                `وزن : ${
                  product?.mozonoVolume?.weight
                    ? "(g)" + product?.mozonoVolume?.weight
                    : "نامعلوم"
                }`
              )}
            </Typography> */}
            {/* <SupportButton /> */}
          </>
        )
      )}
    </>
  );
};
